"use client";

import { motion } from "framer-motion";
import climberImg from "../../assets/images/expedition-gear/exp-suit2.png";

/* ================= SAFE IMAGE SRC ================= */

const climberSrc =
  typeof climberImg === "string" ? climberImg : climberImg.src;

/* ================= SVG GEAR POINTS ================= */

const GEAR_POINTS = [
  { label: "Head Lamp", x: 200, y: 40, lx: 60, ly: 40, align: "left" },
  { label: "Climbing Helmet", 
    x: 230, //increase line length
    y: 60, //increase height of point
    lx: 300, //decrease line length
    ly: 60, //increase height of text
    align: "right" },
  { label: "Snow Goggles", x: 190, y: 70, lx: 60, ly: 70, align: "left" },
  { label: "Oxygen Mask", x: 220, y: 95, lx: 340, ly: 95, align: "right" },

  { label: "O2 Cylinder", x: 120, y: 130, lx: 60, ly: 130, align: "left" },
  { label: "Summit Down Suit", x: 200, y: 180, lx: 90, ly: 180, align: "left" },
  { label: "Summit Gloves", x: 270, y: 260, lx: 350, ly: 260, align: "right" },

  { label: "Trekking Pole", x: 90, y: 290, lx: 20, ly: 290, align: "left" },
  { label: "Ice Axe", x: 280, y: 290, lx: 340, ly: 290, align: "right" },
  { label: "Footwear", x: 240, y: 390, lx: 340, ly: 390, align: "right" },
  { label: "Crampons", x: 265, y: 463, lx: 340, ly: 463, align: "right" },
];

/* ================= MOTION ================= */

const container = {
  hidden: {},
  visible: {
    transition: { staggerChildren: 0.22 },
  },
};

const reveal = {
  hidden: { opacity: 0 },
  visible: {
    opacity: 1,
    transition: {
      type: "spring",
      stiffness: 20,
      damping: 22,
      mass: 0.9,
    },
  },
};

const dotPulse = {
  animate: {
    scale: [1, 1.25, 1],
    opacity: [0.6, 1, 0.6],
  },
  transition: {
    duration: 2,
    repeat: Infinity,
    ease: "easeInOut",
  },
};

/* ================= COMPONENT ================= */

export default function ExpeditionGearDiagram() {
  return (
    <section className="relative w-full flex justify-center">
      <motion.svg
        viewBox="-80 0 520 540"  
        className="w-full max-w-xl  h-auto"
        variants={container}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-120px" }}
      >
        {/* CLIMBER IMAGE */}
        <image
          href={climberSrc}
          x="0"
          y="0"
          width="400"
          height="520"
          preserveAspectRatio="xMidYMid meet"
        />

        {/* CALLOUTS */}
        {GEAR_POINTS.map((p, i) => (
          <motion.g key={i} variants={reveal}>
            <line
              x1={p.x}
              y1={p.y}
              x2={p.lx}
              y2={p.ly}
              stroke="#192c37"
              strokeOpacity="0.5"
              strokeDasharray="4 4"
              strokeWidth="1.5"
            />

            <motion.circle
              cx={p.x}
              cy={p.y}
              r="4"
              fill="#5eff00"
              filter="drop-shadow(0 0 6px rgba(94,255,0,0.8))"
              {...dotPulse}
            />

            <text
              x={p.align === "right" ? p.lx + 6 : p.lx - 6}
              y={p.ly + 4}
              textAnchor={p.align === "right" ? "start" : "end"}
              fontSize="12"
              fill="#192c37"
              style={{ fontWeight: 400, whiteSpace: "nowrap" }}
            >
              {p.label}
            </text>
          </motion.g>
        ))}
      </motion.svg>
    </section>
  );
}
